<div class="ghost"></div>
<div class="header mobile-header-only">
  <div class="wrapper-home" (click)="goToZilex()">

    <div class="placeholder"></div>

  </div>
  <app-header></app-header>
  <app-language-menu (onLanguageChange)="vmOnLanguageChange($event)"></app-language-menu>
</div>
<div class="main-container">

  <div class="header desktop-header-only">
    <div class="wrapper-home" (click)="goToZilex()">
      <div class="icon-wrapper">
        <div class="placeholder"></div>
      </div>
      <div class="text">
        zilex.de
      </div>
    </div>
    <app-header></app-header>
    <app-language-menu (onLanguageChange)="vmOnLanguageChange($event)"></app-language-menu>
  </div>
  <div class="wrapper-main">
    <div class="wrapper-right">
      <form #resetPasswordForm="ngForm" class="settings-form" (submit)="submitResetPassword(resetPasswordForm)">
        <!-- title start -->
        <div class="title">{{'resetPasswordPage.title' | translate}}</div>


        <div class="field">
          <label for="password">{{'resetPasswordPage.password' | translate}}:</label>
          <input type="password" name="password" id="password" [(ngModel)]="password" (input)="validate()" required>
        </div>

        <div class="field">
          <label for="confirmPassword">{{'resetPasswordPage.confirmPassword' | translate}}:</label>
          <input type="password" name="confirmPassword" id="confirmPassword" [(ngModel)]="confirmPassword" required>
        </div>

        <div class="buttons-block">
          <button class="btn btn-cancel" (click)="cancel();">{{'resetPasswordPage.cancelButton' | translate}}</button>
          <button type="submit" class="btn btn-green">OK</button>
        </div>

        <div class="reset-password-validation-errors">
          <!-- invalid message start -->
          <div class="invalidMsg" *ngIf="allFieldsRequired">
            {{'registration.form.validationMsg.allFieldsRequired'|translate}}</div>
          <!-- invalid message end -->

          <!-- not equal passwords message start -->
          <div class="invalidMsg" *ngIf="passwordsNotEqual">
            {{'registration.form.validationMsg.passwordsNotEqual'|translate}}</div>
          <!-- not equal passwords message end -->

          <!-- not equal passwords message start -->
          <div class="warningMsg" *ngIf="passwordLengthFail">
            {{'registration.form.validationMsg.passwordLengthCheckFail'|translate}}</div>
          <div class="warningMsg" *ngIf="passwordSymbolFail">
            {{'registration.form.validationMsg.passwordSymbolCheckFail'|translate}}</div>
          <div class="warningMsg" *ngIf="passwordLetterOrNumberFail">
            {{'registration.form.validationMsg.passwordLetterOrNumberFail'|translate}}</div>
          <!-- not equal passwords message end -->
        </div>
      </form>
    </div>
  </div>

</div>